import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ticktick = defineConnector({
  identifier: "ticktick",
  name: "TickTick",
  tagLine: "Task management and to-do lists",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://api\\.ticktick\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a TickTick app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [TickTick Developer Center](https://developer.ticktick.com/manage) and register a new app. After creating the app, you'll be given a client ID and client secret.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/ticktick/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your TickTick account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your TickTick account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://ticktick.com/oauth/authorize",
    tokenEndpoint: () => "https://ticktick.com/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    clientCredentialsFrom: "db",
    scopes: () => ["tasks:read", "tasks:write"],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.ticktick.com/open/v1/project",
  },
});
